/* src/app/workshop/components/settings/vehicletypes/vehicletypes.component.scss */
/*# sourceMappingURL=vehicletypes.component.css.map */
